/* src/app/shared/terms-and-conditions/components/view-terms-and-conditions-modal/view-terms-and-conditions-modal.component.scss */
.wrapper {
  margin: 2rem;
}
:host ::ng-deep .formio-component-submit {
  display: none;
}
/*# sourceMappingURL=view-terms-and-conditions-modal.component-5MI6R26B.css.map */
